module.exports = __webpack_public_path__ + "972983c0171914fe6ed42a6b076205d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tls-logo.jpg
// module id = 492
// module chunks = 0